export const NAMESPACE = "ZonesSelector";

export const ZONES_MODAL_SELECTOR_INSTANCE = "ZonesSelectorModal";
